import Api from "../service/api";
import { interact, URLS } from "fire-wind-water";
import WX from "../utils/wx";
import WeChat from "@/components/WeChat";
import Header from "@/components/Header.vue";
import FormStatus from "@/components/FormStatus.vue";
import PcFields from "@/components/PcFields.vue";
import { resultData } from "@/service/mock";
import { forkJoin } from "rxjs";
import Utils from "../utils";
const resultMixin = {
  data() {
    return {
      questionnaireId:
        URLS.getURL("questionaryId") || URLS.getHash("questionaryId"),
      sess: "",
      resultList: [],
      questionItem: [],
      getScore: 0,
      totalScore: 0,
      answerId: URLS.getURL("answerId") || URLS.getHash("answerId"),
      questionRulesInfo: [],
    };
  },
  components: {
    WeChat,
    FormStatus,
    Header,
    PcFields,
  },
  created() {
    if (this.isSetting) {
      this.initMockResult();
      return;
    }
    this.module = window.$sk.template.module(this);
  },
  beforeDestroy() {
    this.module.unsubscribe();
  },
  methods: {
    skUserInit() {
      console.log("获取用户本地信息");
    },
    skUserEnd() {
      console.log("获取用户信息结束");
      const info = window.$sk.template.get();
      this.schemaId = info.common.schemaId;
      this.instanceId = info.common.instanceId;
      this.tenantId = info.common.tenantId;
      this.sess = info.user.session;
      this.globalUserId = info.user.globalUserId;
      forkJoin([
        this.resultGet(),
        this.questionRulesGet(),
        this.questionnaireGet(),
      ]).subscribe((res) => {
        if (interact.isWeChat) {
          WX.initWeChatShare(res[2].content);
        }
        this.resultList = res[0].content.items;
        this.getScore = res[0].content.getScore;
        this.totalScore = res[0].content.totalScore;
        this.questionRulesInfo = res[1].content.items;
        this.questionItem = res[2].content.items;
        this.handleList();
        this.handleRules();
      });
      this.questionnaireGet();
      const id = URLS.getURL("configId") || URLS.getHash("configId");
      this.initConfig(id, this.tenantId);
    },
    skUserChange() {
      console.log("用户信息发生改变");
    },
    skLinkEnd() {
      console.log("跳转逻辑判断完毕");
    },
    handleList() {
      let res = this.resultList ? this.resultList : [];
      let needHideQuestion = [];
      let ruleModel = {};
      let hideData = {};
      if (this.questionRulesInfo.length > 0) {
        this.questionRulesInfo.forEach((r) => {
          r.rules.forEach((item) => {
            if (item.rulesJump == 3) {
              needHideQuestion.push(item.rulesGoto);
            }
          });
        });
      }
      res.forEach((m, index) => {
        //问卷规则 随机问卷没有规则
        if (this.questionRulesInfo.length > 0) {
          ruleModel = this.questionRulesInfo.find((r) => {
            return r.rulesCode == m.fieldName;
          });
          hideData = needHideQuestion.filter((r) => {
            return m.fieldName == r;
          });
          m.sortBy = index; //用于跳题隐藏
          m.value = m.answers || m.value;
          if (
            ruleModel &&
            (m.fieldLevel == 1 || m.fieldLevel == 2 || m.fieldLevel == 3) &&
            Array.isArray(m.value) &&
            m.value.length > 0
          ) {
            m.value = this.dicValueConvert(m);
          }
          if (ruleModel) {
            m.rulesInfo = {
              rulesType: ruleModel.rulesType,
              rules: ruleModel.rules,
            };
          }
          m.isShow = hideData.length > 0 ? false : true;
          m.isOldShow = m.isShow; //后面切换题目 还原数据需要
          m.displayType = m.displayType || Utils.changeType(m.type);
        } else {
          m.isShow = true;
        }
      });
      debugger;
      return res;
    },
    dicValueConvert(m) {
      //字典中文转换为dicId;
      let value = "";
      let child = [];
      if (m.listOptionType == "DICT") {
        this.questionItem.forEach((a) => {
          if (a.fieldName == m.fieldName) {
            a.dictInfo.forEach((d) => {
              if (d.name == m.value[0]) {
                if (m.value.length == 1) {
                  value = d.paramId;
                } else {
                  for (let key in d.child) {
                    child = d.child[key];
                  }
                  let maxLength = m.value.length;
                  let i = 1;
                  while (i < maxLength) {
                    for (let obj of child) {
                      if (obj.name == m.value[i]) {
                        if (i != maxLength - 1) {
                          for (let key in obj.child) {
                            child = obj.child[key];
                          }
                        } else {
                          value = obj.paramId;
                        }
                        break;
                      }
                    }
                    i++;
                  }
                }
              }
            });
          }
        });
      } else if (m.listOptionType == "CUSTOM") {
        value = m.value.toString();
      }
      return value;
    },
    handleRules() {
      this.resultList.forEach((m) => {
        if (m.rulesInfo && m.rulesInfo.rules.length > 0) {
          this.goToByRules(m);
        }
      });
    },
    resultGet() {
      return Api.getGenerateExamResult({
        globalUserId: this.globalUserId,
        sess: this.sess,
        examResultId: this.answerId,
        questionaryId: this.questionnaireId,
      });
    },
    questionRulesGet() {
      return Api.getQuestionnaireRules({
        tenantId: this.tenantId,
        questionnaireId: this.questionnaireId,
      });
    },
    questionnaireGet() {
      return Api.getQuestionnaire({
        tenantId: this.tenantId,
        questionnaireId: this.questionnaireId,
      });
    },
    initMockResult() {
      this.resultList = resultData.items;
      this.getScore = resultData.getScore;
      this.totalScore = resultData.totalScore;
    },
  },
};
export default resultMixin;
